import type { NotificationPayload } from '@piaas/piaas-ui-toolkit/notifications';
import { type ReactNode, useEffect } from 'react';

import { setNotify, clearNotify } from './notificationBridge';
import { BaseNotificationProvider, useNotification } from './notifications';

interface NotificationProviderProps {
  children: ReactNode;
}

// Bridges the legacy redux `notifier` actions (still used by some epics/pages)
// into the shared toolkit provider - has to live here, outside the toolkit,
// since it wires a piaas-ui-specific singleton.
const BridgeWiring = () => {
  const { push } = useNotification();

  useEffect(() => {
    setNotify((payload: unknown) =>
      typeof payload === 'string'
        ? push({ message: payload })
        : push(payload as NotificationPayload)
    );
    return () => {
      clearNotify();
    };
  }, [push]);

  return null;
};

const NotificationProvider = ({ children }: NotificationProviderProps) => (
  <BaseNotificationProvider>
    <BridgeWiring />
    {children}
  </BaseNotificationProvider>
);

export default NotificationProvider;
